/**
 * Ant Design clones header cells (including buttons) into `.ant-table-measure-row`
 * with `aria-hidden="true"`. Those clones stay in the tab order and fail axe.
 * Mark measure rows as `inert` whenever they appear in the DOM.
 */
export function startInertTableMeasureRows(): () => void {
  const apply = (root: ParentNode = document) => {
    const rows =
      typeof (root as Element).querySelectorAll === 'function'
        ? (root as Element).querySelectorAll('.ant-table-measure-row')
        : document.querySelectorAll('.ant-table-measure-row');

    rows.forEach((row) => {
      const el = row as HTMLElement;
      if (!el.hasAttribute('inert')) {
        el.setAttribute('inert', '');
      }
    });
  };

  apply();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList') continue;
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('.ant-table-measure-row')) {
          (node as HTMLElement).setAttribute('inert', '');
        }
        node.querySelectorAll?.('.ant-table-measure-row').forEach((row) => {
          (row as HTMLElement).setAttribute('inert', '');
        });
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  return () => observer.disconnect();
}
